import React from "react";
import {
  View,
  Text,
  StyleSheet,
  SafeAreaView,
  ScrollView,
  Platform,
  KeyboardAvoidingView,
  TextInput,
  Image,
  TouchableOpacity,
} from "react-native";
import type { TextInput as RNTextInput } from "react-native";
import { SessionState, useSessionStore } from "../../../../../../state/src/useSessionStore";
import Colors from "../../../../constants/colors";
import EnglishFlag from "../../../../../../../assets/images/english-flag.png";
import RightArrow from "../../../../../../../assets/images/rightArrow.png";

type Props = {
  title?: string;
  subTitle?: string;
  inputRef?: React.RefObject<RNTextInput>;
  phoneNumber: string;
  formatPhoneNumber: (number: string) => string;
  handlePhoneChange: (text: string) => void;
};

const PhoneNumberComponent: React.FC<Props> = ({
  title,
  subTitle,
  inputRef,
  phoneNumber,
  formatPhoneNumber,
  handlePhoneChange,
}) => {
  const isBillPay = useSessionStore((s: SessionState) => (s as any).isBillPay);
  const Wrapper = Platform.OS === "web" ? View : SafeAreaView;
  return (
    <Wrapper style={styles.container}>
      <KeyboardAvoidingView
        behavior={Platform.OS === "ios" ? "padding" : "height"}
      >
        <ScrollView
          contentContainerStyle={[styles.scrollContainer, { flexGrow: 1 }]}
          keyboardShouldPersistTaps="handled"
          keyboardDismissMode="on-drag"
        >
          <View style={styles.content}>
            <Text style={styles.title}>{title}</Text>
            <Text style={styles.subtitle}>{subTitle}</Text>
            {/* {isBillPay && (
              <View style={{ flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', marginBottom: 36}}>
                <View style={{flexDirection: 'row'}}>
                  <Image source={EnglishFlag} style={{ width: 48, height: 48, borderRadius: 50, marginRight: 12}}/>
                  <View>
                    <Text style={styles.companyName}>Ford Credit</Text>
                    <Text style={styles.deliveryText}> Utility {'\n'}Delivery in 2-3 business days</Text>
                  </View>
                </View>
                <TouchableOpacity>
                  <Image source={RightArrow} style={{ width: 24, height: 24}} />
                </TouchableOpacity>
              </View>
            )} */}

            <View style={styles.phoneInputContainer}>
              <View style={styles.countryCodeSelector}>
                <Image
                  source={EnglishFlag}
                  style={{ height: 24, width: 24, borderRadius: 50 }}
                  resizeMode="contain"
                />
                <Text style={styles.plusText}>+1</Text>
              </View>

              <TextInput
                ref={inputRef}
                style={styles.textInput}
                placeholder="Enter phone number"
                placeholderTextColor="#9CA3AF"
                keyboardType="numeric"
                maxLength={12}
                value={formatPhoneNumber(phoneNumber)}
                onChangeText={handlePhoneChange}
                returnKeyType="done"
                textContentType="telephoneNumber"
                autoComplete="tel"
                autoCorrect={false}
                autoFocus
              />
            </View>
            {/* {
              isBillPay && (
                <TextInput
                  style={styles.inputWrapper}
                  placeholder={'Biller Account Number'}
                  keyboardType="numeric"
                  value={""}
                  onChangeText={() => {}}
                />
              )
            } */}
          </View>
        </ScrollView>
      </KeyboardAvoidingView>
    </Wrapper>
  );
};

export default PhoneNumberComponent;

const styles = StyleSheet.create({
  container: { backgroundColor: Colors.white },
  scrollContainer: {
    paddingHorizontal: 24,
    paddingBottom: 40,
    alignItems: "stretch",
  },
  content: { marginTop: 8 },
  title: {
    fontSize: 28,
    fontWeight: "500",
    color: Colors.titleTextColor,
    lineHeight: 34,
  },
  subtitle: {
    fontSize: 16,
    fontWeight: "400",
    color: Colors.subTitleColor,
    lineHeight: 24,
    marginBottom: 32,
  },
  phoneInputContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 30,
  },
  countryCodeSelector: {
    height: 56,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: Colors.textInputBackground,
    borderRadius: 8,
    paddingHorizontal: 16,
    marginRight: 8,
  },
  plusText: { fontSize: 14, fontWeight: "700", color: "#111827" },
  textInput: {
    flex: 1,
    height: 56,
    backgroundColor: Colors.textInputBackground,
    borderRadius: 8,
    paddingHorizontal: 16,
    fontSize: 16,
    color: "#111827",
  },
  companyName: {
    fontSize: 16,
    fontWeight: "400",
    color: Colors.titleTextColor,
    lineHeight: 24,
  },
  deliveryText: {
    fontSize: 12,
    fontWeight: "400",
    color: Colors.titleTextColor,
    lineHeight: 16
  },
  inputWrapper: {
    // marginTop: 49,
    height: 56,
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 8,
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 24,
    color: '#737373'
  },
});